import { fa0, fa1 } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function NavCard({ icon, title, numberIcons, onClick, className, iconSize }) {
  return (
    <div onClick={onClick} className={`${className} p-5 w-full grid grid-cols-3 rounded cursor-pointer shadow-lg p-5 transition-all ease-linear duration-300`}>
      <div className='text-lg col-span-2 text-white'>
        {title}
        <div>
          <span>
            {numberIcons?.map((icon) => (
              <FontAwesomeIcon icon={icon} size={'1x'} color='white' />

            ))}
          </span>
        </div>
      </div>
      <div className='text-lg col-span-1 text-slate-100/80 flex justify-end items-center uppercase'>
        <FontAwesomeIcon icon={icon} size={iconSize || 'lg'} />
      </div>
    </div>
  )
}
